var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0859 9.45898H7.08594C6.74427 9.45898 6.46094 9.17565 6.46094 8.83398C6.46094 8.49232 6.74427 8.20898 7.08594 8.20898H12.0859C12.4276 8.20898 12.7109 8.49232 12.7109 8.83398C12.7109 9.17565 12.4276 9.45898 12.0859 9.45898Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58594 11.959H7.08594C6.74427 11.959 6.46094 11.6757 6.46094 11.334C6.46094 10.9923 6.74427 10.709 7.08594 10.709H9.58594C9.9276 10.709 10.2109 10.9923 10.2109 11.334C10.2109 11.6757 9.9276 11.959 9.58594 11.959Z",
    fill: "#92ABFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.58073 17.9993C13.953 17.9993 17.4974 14.4549 17.4974 10.0827C17.4974 5.71043 13.953 2.16602 9.58073 2.16602C5.20847 2.16602 1.66406 5.71043 1.66406 10.0827C1.66406 14.4549 5.20847 17.9993 9.58073 17.9993Z",
    fill: "#92ABFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7521 18.8335C17.6021 18.8335 17.4521 18.7751 17.3437 18.6668L15.7938 17.1168C15.5688 16.8918 15.5688 16.5251 15.7938 16.2918C16.0188 16.0668 16.3854 16.0668 16.6187 16.2918L18.1687 17.8418C18.3937 18.0668 18.3937 18.4335 18.1687 18.6668C18.0521 18.7751 17.9021 18.8335 17.7521 18.8335Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchStatus);
export default __webpack_public_path__ + "static/media/search-status.83fb45a6c4c5e8f360e320f6e0665f50.svg";
export { ForwardRef as ReactComponent };